import React, { useEffect, useState } from 'react';
import DoughnutGauge from './DoughnutGauge';
import BarChart from '../../../common/components/charts/BarChart';
import DashboardCard from './DashboardCard';

import { useGetAssessmentPeriodMetricResultsQuery } from 'areas/assessment-schedule/api';
import { Page } from 'react-pdf';
import { PageSection, Title } from '@/common/styles/page';
import TeamPillarBarChart from '@/areas/team-recommendations/components/TeamPillarBarChart';
interface DashboardPillarScoresProps {
  assessment_period_id: number;
}

const DashboardPillarScores: React.FC<DashboardPillarScoresProps> = ({
  assessment_period_id,
}) => {
  const [pillarScores, setPillarScores] = useState<{ label: string; value: number }[]>([]);
  const [overallScore, setOverallScore] = useState(0);

  const { data } = useGetAssessmentPeriodMetricResultsQuery(
    { assessmentPeriodId: assessment_period_id },
    {
      skip: !assessment_period_id,
    }
  );

  useEffect(() => {
    if (data && !Array.isArray(data)) {
      const factorScoreData = data.pillars || [];
      const scores = factorScoreData.map((item: { label: string; average_response: number | string | null | undefined }) => {
        const numericValue = Number(item?.average_response ?? 0);
        return {
        label: item.label,
          value: Number.isFinite(numericValue) ? parseFloat(numericValue.toFixed(1)) : 0,
        };
      });

      setPillarScores(scores);
      const numericOverallScore = Number(data.overall_score ?? 0);
      setOverallScore(Number.isFinite(numericOverallScore) ? numericOverallScore : 0);
    } else {
      setPillarScores([]);
      setOverallScore(0);
    }
  }, [data]);

  if (assessment_period_id === undefined) {
    return (
      <>
        <DoughnutGauge title={'Overall Score'} max={10} complete={0} precision={1} />
        <p style={{ textAlign: 'left', color: 'gray', paddingLeft: '20px' }}>
          No assessment data is available. Complete and close an assessment period to view
          aggregates, select goals, and start projects.
        </p>
      </>
    );
  }
  
  return (
    <PageSection display='flex' flexDirection='column' width='100%' padbottom='10px'>
      <Title padbottom="10px">Culture Pillars</Title>

      <PageSection display='flex' width='100%'>
        <DoughnutGauge title={'Overall Score'} max={10} complete={overallScore} precision={1} />
        <TeamPillarBarChart data={pillarScores} multiple={10} percent={false} />
      </PageSection>
    </PageSection>
  );
};

export default DashboardPillarScores;

